import { Component, Input } from '@angular/core';

import { ViewGroupedAction } from '../view-grouped-action.model';

@Component({
    selector: 'cmps-gp-action',
    templateUrl: './action.component.html',
})
export class ActionComponent {
    @Input() groupedAction: ViewGroupedAction;
    @Input() isBest = false;
    @Input() name: string;
}
